import React from 'react';
import _ from 'lodash';

const sequence =
  '1qaz2wsx3edc4rfv5tgb6yhn7ujm8ik9ol0p1QAZ2WSX3EDC4RFV5TGB6YHN7UJM8IK9OL0P';

export const randomKey = length => {
  let key = '';

  for (let i = 0; i < length; ++i) {
    key += sequence.charAt(Math.random() * sequence.length);
  }

  return key;
};

export const call = (func, ...args) => {
  if (typeof func === 'function') {
    return func(...args);
  }
};

export const copyToClipboard = value => navigator.clipboard.writeText(value);

export const classes = (...args) => args.filter(it => !!it).join(' ');

export const sanitize = val =>
  _.deburr(
    _.trim(
      _.trim(_.toString(val))
        .replace(/\/+$/g, '')
        .replace(/^\/+/g, '')
        .replace(/(https?:\/\/)|(\/)+/g, '$1$2')
    )
  );

export const forwardLink = (props, path, forwardState, restoreState, nested = true) => ({
  pathname: nested
    ? `${(_.get(props, 'location.pathname') || '').replace(/\/+$/, '')}/${(
        path || ''
      ).replace(/(^\/+|\/+$)/g, '')}`
    : path,

  state: {
    ...forwardState,
    restore: {
      pathname: _.get(props, 'location.pathname'),
      state: { ..._.get(props, 'location.state'), ...restoreState },
    },
  },
});

export const backLink = (props, fallback) => {
  if (_.get(props, 'location.state.restore.pathname')) {
    return props.location.state.restore;
  }

  if (typeof fallback === 'string') {
    return fallback;
  }

  let pathname = _.get(props, 'location.pathname');

  if (pathname) {
    let rewind = typeof fallback === 'number' ? Math.max(1, fallback) : 1;

    do {
      pathname = pathname.substring(0, pathname.lastIndexOf('/'));
    } while (--rewind);

    return pathname;
  }

  return '/';
};

export const forwardIdLink = (props, id) => {
  const link = _.pick(_.get(props, 'location'), ['pathname', 'state']);

  if (link.pathname) {
    link.pathname = `/${sanitize(link.pathname)}/${id}`;
    return link;
  }
};

export const renderElement = (Component, props) =>
  Component ? <Component {...props} /> : null;

export const scrollIntoView = el => {
  if (el && typeof el.scrollIntoView === 'function') {
    try {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    } catch (err) {
      el.scrollIntoView();
    }
  }
};

export const buildImageUrl = ({ container, blob }, wrap = true) => {
  const url = `https://${container}.s3.amazonaws.com/${blob}`;
  return wrap ? `url(${url})` : url;
};

export const breakSentence = (val, size) => {
  if (typeof val !== 'string' || typeof size !== 'number' || size < 1) {
    return [];
  }

  const lines = [];

  let line = [];
  let length = 0;

  for (const item of val.split(/\s+/)) {
    if (item) {
      const newLength = length + (length ? 1 + item.length : item.length);
      console.log(item, item.length, newLength);

      if (newLength > size && length) {
        lines.push(line.join(' '));
        line = [item];
        length = item.length;
      } else {
        line.push(item);
        length = newLength;
      }
    }
  }

  if (length) {
    lines.push(line.join(' '));
  }

  return lines;
};

export const toNumber = (value, maxLength) =>
  _.toNumber(_.replace(value, /[^0-9]/g, '').substring(0, maxLength));

export const attachRef = (ref, middleware) => el => {
  if (el) {
    if (typeof middleware === 'function') {
      el = middleware(el) || el;
    }

    if (typeof ref === 'function') {
      ref(el);
    } else if (ref) {
      ref.current = el;
    }
  }
};
